import type { TechnicalDataCategoryView, TechnicalDataView } from "@slfinrtl/ui-bff-routes"
import { getTechnicalDataRoute } from "@slfinrtl/ui-bff-routes"
import { useEffect, useState } from "react"
import { useBff } from "src/hooks"
import { useVehicleDetailsContext } from "../../../context/VehicleDetailsContext"

export const useTechnicalData = (): TechnicalDataCategoryView[] | undefined | null => {
	const [technicalDataView, setTechnicalDataView] = useState<TechnicalDataView | null>()
	const { inventoryId, notify } = useVehicleDetailsContext()

	const fetchTechnicalData = useBff(
		getTechnicalDataRoute,
		{
			body: undefined,
			pathParams: {},
			queryParams: {
				"inventory-id": inventoryId,
			},
		},
		"inline",
	)

	useEffect(() => {
		fetchTechnicalData()
			.then(setTechnicalDataView)
			.catch(() => setTechnicalDataView(null))
	}, [fetchTechnicalData])

	useEffect(() => {
		if (technicalDataView !== undefined) {
			notify({ event: "technicalDataChanged", payload: technicalDataView })
		}
	}, [technicalDataView, notify])

	return technicalDataView === null ? null : technicalDataView?.categorized
}
